const _excluded = ["setEnabled"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { fetchWithTokenAndRegion, getBim360AdminUrl, getCurrentToken, getCurrentTokenWithoutRedirect, getOxygenId } from '@adsk/acs-sc-web-platform-api';
import { useSWRAlloy, CONTEXT_NAMES } from '@adsk/alloy-helpers';
import { getOrCreateGlobalContext, useContextWithValidation } from '@adsk/alloy-react-context';
import { parseUser } from './helpers/parseUser';
/**
 * Context for current user.
 */
const UserContext = getOrCreateGlobalContext(CONTEXT_NAMES.UserContext);
const useUserContext = () => useContextWithValidation(UserContext, {
  hook: 'useUser',
  provider: 'UserProvider'
});
export const useOptionalUser = () => {
  const _useUserContext = useUserContext(),
    {
      setEnabled
    } = _useUserContext,
    rest = _objectWithoutProperties(_useUserContext, _excluded);
  useEffect(() => {
    if (setEnabled) {
      setEnabled(true);
    }
  }, [setEnabled]);
  return rest;
};
const fetchUser = () => getCurrentToken().then(_ref => {
  let {
    accessToken
  } = _ref;
  const oxygenId = getOxygenId(accessToken);
  return fetchWithTokenAndRegion("".concat(getBim360AdminUrl(), "/v1/users/").concat(oxygenId)).then(parseUser);
});
export const UserProvider = _ref2 => {
  let {
    children,
    redirectLoggedOutUsers,
    disabled
  } = _ref2;
  const [enabled, setEnabled] = useState(!disabled);
  const {
    data: fetchData,
    error,
    revalidate: retry,
    mutate
  } = useSWRAlloy(enabled ? '/current_user' : null, () => {
    const fetchUserFn = redirectLoggedOutUsers || !enabled ? fetchUser : () => getCurrentTokenWithoutRedirect().then(() => fetchUser());
    return fetchUserFn().catch(e => {
      if (redirectLoggedOutUsers) {
        console.error('AlloyProvider - UserContext: Error fetching current user', e);
      }
      throw e;
    });
  });
  const data = (error === null || error === void 0 ? void 0 : error.status) === 401 ? null : fetchData;
  const loading = !data && !error;
  const setUser = useCallback(newData => mutate(newData, false), [mutate]);
  return /*#__PURE__*/React.createElement(UserContext.Provider, {
    value: {
      error,
      loading,
      data,
      retry,
      setUser,
      setEnabled: enabled ? undefined : setEnabled
    }
  }, children);
};
UserProvider.displayName = 'UserProvider';
UserProvider.defaultProps = {
  redirectLoggedOutUsers: true
};
UserProvider.propTypes = {
  /** Whether to redirect logged out users to login page. */
  redirectLoggedOutUsers: PropTypes.bool,
  /** Whether we should disable this provider */
  disabled: PropTypes.bool,
  /** Nodes with access to context */
  children: PropTypes.node
};
//# sourceMappingURL=UserContext.js.map